import { Icon, Input, Select, Button, Popover, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import style from "../solo.module.sass";
import cancelSvg from '../../../../../assets/svg/solo/closeBtn.svg';
import SoloServcie from "../../../../../assets/svg/solo/soloServiceIco.svg"
import buildin from "../../../../../assets/svg/solo/BuiltInService.svg"
import StringIcon from "../../../../../assets/svg/solo/s.svg"
import JsonIcon from "../../../../../assets/svg/solo/j.svg"
import integerIcon from "../../../../../assets/svg/solo/i.svg"
import booleanIcon from "../../../../../assets/svg/solo/b.svg"
import variableAclIcon from "../../../../../assets/svg/solo/variableAclConfigured.svg"
import emptyVariableAclIcon from "../../../../../assets/svg/solo/variableAclNotConfigured.svg"
import CodeEditior from "../codeEditor/CodeEditor"
import VariableAcl from "./VariableAcl";
//import custom from "../../../../../assets/svg/solo/customservice.svg"
import "../create/flow.css"
import _ from "lodash";

const { Option } = Select;

const Service = (props: any) => {/* eslint-disable */
    const { nodeDetail, soloServices, soloBuildinServices, elements, widgetDrawer, form, showVariableAcl, setShowVariableAcl, setAclIcon, nodesContext } = props;
    const [serviceValues, setServiceValues]: any = useState([])
    const [serviceName, setServiceName]: any = useState(null);
    const [name, setName]: any = useState(null)
    const [id, setId]: any = useState(0)
    const [serviceType, setServiceType]: any = useState(null)
    const [services, setServices]: any = useState(null)
    const [showAddIcon, setShowAddIcon]: any = useState(true)
    const [valueCheck, setValueCheck]: any = useState(null)
    const [selectedService, setSelectedService]: any = useState(null)
    const [serviceKey, setServiceKey]: any = useState(null);
    const [nodes, setNodes]: any = useState(null);
    const [nextNode, setNextNode]: any = useState(null);
    const [requiredParams, setRequiredParams]: any = useState([]);
    const [paramChanges, setParamchanges]: any = useState(true)
    const [showAddParameter, setShowAddParameter]: any = useState(true)
    const [paramsRequiredfield, setParamsRequiredfield]: any = useState(false)
    const [serviceProperties, setServiceProperties]: any = useState({ nodeId: null, name: "", selectedserviceName: "" })
    const [params, setParams]: any = useState(null)
    const [selectedForm, setSelectedForm]: any = useState(null);
    const [formKey, setFormKey]: any = useState(null)
    const [showRequiredFields, setShowRequiredFields]: any = useState(false)
    const [openDropDownType, setOpenDropDownTypes]: any = useState(null)
    const [findIndex, setFindIndex]: any = useState(null)
    const [selectedType, setSelectedType] = useState("")
    const [additionalParams, setAdditionalParams] = useState(false)
    const [disableSave, setDisableSave] = useState(false)
    const [spaceKeyPressed, setSpaceKeyPressed]: any = useState(false)
    const [showCodeEditor, setShowCodeEditor] = useState<boolean>(false)
    const [jsonValue, setJsonValue] = useState(null);
    const [findJsonIndex, setFindJsonIndex] = useState(0);
    const [variableAcl, setVariableAcl] = useState({});
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")
    const { eventNodeServiceConnections = []  } = nodesContext
    const { ModalSelectedValues } = useSelector((state: any) => state.solo)
    const [check, setCheck] = useState<boolean>(false)
    const variablesTypes = [
        { id: 1, type: "String", src: StringIcon },
        { id: 2, type: "Integer", src: integerIcon },
        { id: 3, type: "Boolean", src: booleanIcon },
        { id: 4, type: "Json", src: JsonIcon }
    ];

    useEffect(() => {
        let key: any;
        if (ModalSelectedValues !== null && (ModalSelectedValues && ModalSelectedValues.id === nodeDetail.id)) {
            if (ModalSelectedValues && !ModalSelectedValues.key) {
                soloServices && soloServices.map((serv: any) => {
                    if (serv.name === ModalSelectedValues.name) {
                        key = serv.serviceKey;
                    }
                })
            }
            if (ModalSelectedValues.name !== selectedService) {
                services && services.forEach((service: any) => {
                    let arr: any = [];
                    if (service.name === ModalSelectedValues.name) {
                        if (Object.keys(service.params).length > 0) {
                            setParams(service.params)
                            arr = findServiceKeyValue(service, ModalSelectedValues.name)
                            arr.length && setServiceValues(arr)
                            if (service.additionalParams) {
                                setAdditionalParams(service.additionalParams)
                                setShowAddParameter(true)
                                setShowAddIcon(true)
                            } else if (!service.additionalParams) {
                                setAdditionalParams(service.additionalParams)
                                setShowAddParameter(false)
                                setShowAddIcon(false)
                            }
                        } else {
                            setServiceValues([])
                            setShowRequiredFields(false)
                            setParamsRequiredfield(false)
                            setShowAddParameter(true)
                            setShowAddIcon(true)
                            setAdditionalParams(true)
                        }
                    } else if (ModalSelectedValues.name !== "" && service.name !== ModalSelectedValues.name && !service.type && !service.params) {
                        setServiceValues([])
                        setShowRequiredFields(false)
                        setParamsRequiredfield(false)
                        setShowAddParameter(true)
                        setShowAddIcon(true)
                        setAdditionalParams(true)
                    }
                })
            }
            setSelectedService(ModalSelectedValues.name || selectedService)
            setServiceType(ModalSelectedValues.type)
            setServiceKey(ModalSelectedValues.key ? ModalSelectedValues.key : key || serviceKey)
        }
    }, [ModalSelectedValues, soloServices])

    useEffect(() => {
        let arr: any = []
        let targetNodeFind: any;
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        if (services && (nodeDetail.data.propertyDetails === undefined || paramChanges)) {
            const { propertyDetails } = nodeDetail.data;
            services.forEach((service: any) => {
                if (service.name === selectedService) {
                    if (service.serviceKey) {
                        if ((propertyDetails
                            && propertyDetails.params || propertyDetails && propertyDetails.params === undefined)
                            && propertyDetails.serviceKey || !propertyDetails || propertyDetails
                            && !propertyDetails.serviceKey) {
                            if (Object.keys(service.params).length > 0) {
                                setParams(service.params)
                                let arr: any = [];
                                arr = findServiceKeyValue(service, selectedService)
                                arr.length && setServiceValues(arr)
                                if (service.additionalParams) {
                                    setAdditionalParams(service.additionalParams)
                                    setShowAddParameter(true)
                                    setShowAddIcon(true)
                                } else if (!service.additionalParams) {
                                    setAdditionalParams(service.additionalParams)
                                    setShowAddParameter(false)
                                    setShowAddIcon(false)
                                }
                            } else {
                                setServiceValues([])
                                if (service.additionalParams) {
                                    setParamsRequiredfield(true);
                                    setShowAddParameter(true);
                                    setShowAddIcon(true);
                                    setShowRequiredFields(false)
                                    setAdditionalParams(true)
                                } else {
                                    setShowRequiredFields(false)
                                    setShowAddParameter(false);
                                    setShowAddIcon(false);
                                    setShowRequiredFields(false)
                                    setAdditionalParams(false)
                                }

                            }
                        }
                        setServiceKey(service.serviceKey)
                        setServiceType("custom")
                    } else if (service.type) {
                        if (service.additionalParams) {
                            setAdditionalParams(service.additionalParams)
                            setShowAddParameter(true)
                            setShowAddIcon(true)
                        } else if (!service.additionalParams) {
                            setAdditionalParams(service.additionalParams)
                            setShowAddParameter(false)
                            setShowAddIcon(false)
                        }
                        setServiceType(service.type)
                        setServiceKey(null)
                        if (service.params) {
                            setParams(service.params)
                            const arr = findServiceKeyValue(service, selectedService)
                            arr.length && setServiceValues(arr)
                        } else {
                            setServiceValues([])
                            if (service.additionalParams) {
                                setParamsRequiredfield(true);
                                setShowAddParameter(true);
                                setShowAddIcon(true);
                                setShowRequiredFields(false)
                                setAdditionalParams(true)
                            } else {
                                setShowRequiredFields(false)
                                setShowAddParameter(false);
                                setShowAddIcon(false);
                                setShowRequiredFields(false)
                                setAdditionalParams(false)
                            }
                        }
                    }
                }
            })
        }
    }, [selectedService])


    useEffect(() => {
        if (widgetDrawer && ModalSelectedValues && ModalSelectedValues.name && ModalSelectedValues.id === nodeDetail.id && ModalSelectedValues.name === selectedService && ModalSelectedValues.hasOwnProperty("select")) {
            const currService = services && services.find((item: any) => item.name === ModalSelectedValues.name) || {}
            if (currService) {
                let arr = findServiceKeyValue(currService, ModalSelectedValues.name)
                setServiceValues(arr)
                setAdditionalParams(currService.additionalParams)
                if (currService && currService.requiredParams && currService.requiredParams.length > 0) {
                    !currService.additionalParams && setParams(currService.params)
                    setShowRequiredFields(true)
                    setRequiredParams(currService.requiredParams || [])
                } else {
                    setShowRequiredFields(false)
                }
                if (currService.additionalParams) {
                    setShowAddParameter(true)
                } else {
                    setShowAddParameter(false)
                }
            }
        }
    }, [widgetDrawer])


    useEffect(() => {
        if (soloServices && soloBuildinServices) {
            soloBuildinServices.forEach((solo: any) => {
                const { requiredParams = [] } = solo
                setParams(solo.params)
                setRequiredParams((prevState: any) => [...prevState, ...requiredParams])
            })
            const { serviceName = "" } = nodeDetail && nodeDetail.data && nodeDetail.data.propertyDetails || {}
            if (serviceName) {
                soloServices.forEach((service: any) => {
                    if (service.name === serviceName) {
                        const { requiredParams = [] } = service
                        setParams(service.params)
                        setRequiredParams(requiredParams)
                        setAdditionalParams(service.additionalParams)
                        if (!service.additionalParams) {
                            setShowAddParameter(false)
                        } else {
                            setShowAddParameter(true)
                        }
                    }
                })
            }
            setServices(soloServices.concat(soloBuildinServices))
        }
    }, [soloBuildinServices, soloServices])

    useEffect(() => {
        props.onUpdateProperties(serviceProperties)
    }, [serviceProperties])

    useEffect(() => {
        if (serviceName) {
            setServiceProperties({
                nodeId: nodeDetail.id,
                name: serviceName
            })
        }
    }, [serviceName])

    useEffect(() => {
        if (valueCheck) {
            if (valueCheck && valueCheck.length > 0) {
                setParamsRequiredfield(false)
                setShowAddIcon(true)
            } else {
                setShowAddIcon(false)
            }
        } else if (valueCheck === "") {
            setShowAddIcon(false)
        }
    }, [valueCheck])


    useEffect(() => {
        const result = serviceValues && serviceValues.map((value: any, id: any) => {
            const params = requiredParams && requiredParams.filter((e: any) => { return e })
            if (params.includes(value.key)) {
                if (value && value.value && value.value.length > 0) {
                    setParamsRequiredfield(false)
                    return { ...value, required: false }
                } else {
                    setParamsRequiredfield(true)
                    return { ...value, required: true }
                }
            } else {
                //setParamsRequiredfield(false)
                return { ...value, required: false }
            }
        })
        setServiceValues(result)
    }, [requiredParams])

    useEffect(() => {
        const { serviceName = "" } = nodeDetail.data && nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails || {}
        if (serviceName === 'Delete Session Variables' || selectedService === 'Delete Session Variables') {
            setCheck(serviceValues.some((el: any) => el.value !== ""))
        } else {
            setCheck(true)
        }
    }, [serviceValues]);


    useEffect(() => {
        setSetupActiveTab("freeze")
        setTeardownActiveTab("freeze")
        setAclIcon(emptyVariableAclIcon)
        setShowVariableAcl(false)
        if (nodeDetail.data.propertyDetails) {
            if (nodeDetail.data.propertyDetails.variableAcl?.setup?.freeze || nodeDetail.data.propertyDetails.variableAcl?.setup?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.setup?.hide || nodeDetail.data.propertyDetails.variableAcl?.setup?.unhide ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.freeze || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.hide || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unhide) {
                setAclIcon(variableAclIcon)
            }
            if (nodeDetail.type === "service" && nodeDetail.data.propertyDetails.serviceKeyValue) {
                const findSrcinService = nodeDetail.data.propertyDetails.serviceKeyValue.map((el: any) => {
                    let obj = {}
                    variablesTypes.forEach((variable: any) => {
                        if (variable.type === el.type) {
                            obj = {
                                ...el,
                                src: variable.src
                            }
                        }
                    })
                    return obj;
                })
                setParamchanges(false)
                if (nodeDetail.data.propertyDetails.key) {
                    form && form.forEach((f: any) => {
                         if(f.formKey === nodeDetail.data.propertyDetails.key){
                             setSelectedForm(f.displayName)
                         }
                    })
                } else if (!nodeDetail.data.propertyDetails.key && !nodeDetail.data.propertyDetails.selectedForm) {
                    setSelectedForm(null)
                }else {
                    setSelectedForm(nodeDetail.data.propertyDetails.selectedForm);
                }
                setFormKey(nodeDetail?.data?.propertyDetails?.key)
                setServiceValues(findSrcinService);
                setServiceType(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.serviceType)
                setServiceKey(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.serviceKey)
                let newServices = (soloBuildinServices.concat(soloServices))
                const currentService = newServices && newServices.find((e: any) => e.name === nodeDetail.data.propertyDetails.selectedserviceName) || {}
                findCurrentService(currentService);
                if (nodeDetail.data.propertyDetails.serviceKeyValue.length > 0) {
                    setId(nodeDetail.data.propertyDetails.serviceKeyValue.length)
                } else {
                    if (currentService.additionalParams) {
                        setShowAddParameter(true)
                        setShowAddIcon(true)
                        setShowRequiredFields(false)
                    } else {
                        setShowAddParameter(false)
                        setShowAddIcon(false)
                        setShowRequiredFields(false)
                    }
                }
                const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                if (findNextNode.length) {
                    setNextNode(findNextNode[0].target)
                } else {
                    setNextNode("")
                }
                setName(nodeDetail.data.propertyDetails.name);
                setServiceName(nodeDetail.data.propertyDetails.name);
                setSelectedService(nodeDetail.data.propertyDetails.selectedserviceName);
                setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
            } else {
                const { propertyDetails = {} } = nodeDetail.data
                if (nodeDetail.type === "service") {
                    const { serviceName = "", name = "" } = propertyDetails;
                    setName(name || nodeDetail.id);
                    setServiceName(name || nodeDetail.id);
                    setSelectedService(serviceName);
                    setVariableAcl(props.nodeDetail.data.propertyDetails?.variableAcl || {})

                    let arr: any = []
                    let serviceParamsKeyValue: any;
                    let currServiceAdditionalParams;
                    if (nodeDetail.data.propertyDetails.key) {
                        form && form.map((f: any) => {
                            return (f.formKey === props.nodeDetail.data.propertyDetails.key) &&
                            setSelectedForm(f.displayName)
                        })
                    } else if (!nodeDetail.data.propertyDetails.key){
                        setSelectedForm(null)
                    }
                    setFormKey(nodeDetail?.data?.propertyDetails?.key)
                    if (Object.keys(propertyDetails.params).length > 0) {
                        setParamchanges(false)
                        let keyValue: any = {}
                        const keys = Object.keys(propertyDetails.params && propertyDetails.params)
                        //params[key] && params[key].value ? params[key].value : propertyDetails.params[key].value || (values[id].value === "" || values[id].value) ? values[id].value : !values[id].value ? "" : values[id],
                        // const values: any = Object.values(propertyDetails.params && propertyDetails.params)
                        let newServices = (soloBuildinServices.concat(soloServices))
                        const currentService = newServices && newServices.find((e: any) => e.name === propertyDetails.serviceName) || {}
                        findCurrentService(currentService)
                        const { params = {} } = currentService
                        currServiceAdditionalParams = currentService.additionalParams;
                        serviceParamsKeyValue = findServiceKeyValue(currentService, serviceName)
                        const findParamsKey = Object.keys(params) || [];
                        keys && keys.map((key: any, id: any) => {
                            let findSrc;
                            if (findParamsKey.includes(key)) {
                                findSrc = variablesTypes.findIndex((el: any) => el.type === params[key].type)
                            } else {
                                findSrc = variablesTypes.findIndex((el: any) => el.type === propertyDetails.params[key].type)
                            }
                            keyValue = {
                                id: key,
                                key: key,
                                value: propertyDetails.params[key].value ? propertyDetails.params[key].value : "",
                                type: findParamsKey.includes(key) ? params[key].type : propertyDetails.params[key].type || "String",
                                src: findSrc > 0 ? variablesTypes[findSrc].src : StringIcon,
                                changeType: findParamsKey.includes(key) ? false : true,
                                showCloseIcon: findParamsKey.includes(key) ? false : true,
                                required: findParamsKey.includes(key) ? false : true
                            }
                            arr.push(keyValue)
                        })
                        setId(arr.length)
                    } else if (nodeDetail && nodeDetail.data.propertyDetails && !nodeDetail.data.propertyDetails.serviceKeyValue) {
                        setShowRequiredFields(false)
                        setShowAddParameter(true)
                        let newServices = (soloBuildinServices.concat(soloServices))
                        const currentService = newServices && newServices.find((e: any) => e.name === nodeDetail.data.propertyDetails.serviceName) || {}
                        findCurrentService(currentService)
                        serviceParamsKeyValue = findServiceKeyValue(currentService, serviceName)
                    }
                    if (!nodeDetail.data.propertyDetails.serviceKey && nodeDetail.data.propertyDetails.serviceName) {
                        soloBuildinServices && soloBuildinServices.map((el: any) => {
                            if (nodeDetail.data.propertyDetails.serviceName === el.name && el.additionalParams === true) {
                                setAdditionalParams(true);
                                setShowAddParameter(true);
                                setShowRequiredFields(false);
                            }
                        })
                    }
                    const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                    if (findNextNode.length) {
                        setNextNode(findNextNode[0].target)
                    } else {
                        setNextNode("")
                    }
                    setId(arr.length)
                    setShowAddIcon(true)
                    let combinedSericesParams: any = [];
                    if (serviceParamsKeyValue && serviceParamsKeyValue.length > 0) {
                        const serviceParams = arr.map((e: any) => {
                            if (e.changeType === false) {
                                return e
                            }
                        }).filter((e: any) => { return e })
                        const saveApiParams = arr.map((e: any) => {
                            if (e.changeType === true) {
                                return e
                            }
                        }).filter((e: any) => { return e })
                        combinedSericesParams = [...serviceParams, ...saveApiParams]
                        const findKey: any = [];
                        combinedSericesParams.forEach((e: any) => {
                            findKey.push(e.key)
                        })
                        if (serviceParamsKeyValue.some((e: any) => findKey.includes(e.key))) {
                            const serviceParams = serviceParamsKeyValue.map((e: any) => {
                                if (e.changeType === false) {
                                    return e
                                }
                            }).filter((e: any) => { return e })
                            const saveApiParams = combinedSericesParams.map((e: any) => {
                                if (e.changeType === true) {
                                    return e
                                }
                            }).filter((e: any) => { return e })
                            if (currServiceAdditionalParams) {
                                setServiceValues([...serviceParams, ...saveApiParams])
                            } else {
                                const findKey = serviceParamsKeyValue.map((e: any) => { return e.key })
                                const findFilteredKeyValue = combinedSericesParams.filter((val: any) => { return findKey.includes(val.key) })
                                if (findFilteredKeyValue.length > 0) {
                                    const concatServiceKeyValues = ([...serviceParamsKeyValue, ...findFilteredKeyValue])
                                    const uniqueServiceKeyValue = concatServiceKeyValues.filter((value: any, index: any, array: any) => array.findIndex((i: any) => (i.key === value.key)) === index)
                                    setServiceValues(uniqueServiceKeyValue)
                                } else {
                                    setServiceValues(serviceParamsKeyValue)
                                }
                            }
                        } else {
                            if (currServiceAdditionalParams) {
                                const serviceParams = combinedSericesParams.map((e: any) => {
                                    if (e.changeType === false) {
                                        return e
                                    }
                                }).filter((e: any) => { return e })
                                const saveApiParams = combinedSericesParams.map((e: any) => {
                                    if (e.changeType === true) {
                                        return e
                                    }
                                }).filter((e: any) => { return e })
                                setServiceValues([...serviceParams, ...serviceParamsKeyValue, ...saveApiParams])
                            } else {
                                if (arr.length > 0) {
                                    const newKeyValue = filteredServiceKeyValue(arr, serviceParamsKeyValue)
                                    if (newKeyValue.length > 0) {
                                        setServiceValues(newKeyValue)
                                    } else {
                                        const findKey = combinedSericesParams.map((key: any) => {
                                            return key.key
                                        })
                                        const newKeyValue = serviceParamsKeyValue.filter((keys: any) => {
                                            return !findKey.includes(keys.key)
                                        })
                                        setServiceValues(newKeyValue)
                                    }
                                } else {
                                    const serviceParams = combinedSericesParams.map((e: any) => {
                                        if (e.changeType === false) {
                                            return e
                                        }
                                    }).filter((e: any) => { return e })
                                    const saveApiParams = combinedSericesParams.map((e: any) => {
                                        if (e.changeType === true) {
                                            return e
                                        }
                                    }).filter((e: any) => { return e })
                                    setServiceValues([...serviceParams, ...serviceParamsKeyValue, ...saveApiParams])
                                    // setServiceValues([...combinedSericesParams, ...serviceParamsKeyValue])
                                }
                            }
                        }
                    } else if (currServiceAdditionalParams) {
                        setServiceValues(arr)
                    } else if (!currServiceAdditionalParams) {
                        setServiceValues([])
                        setShowAddParameter(false)
                    }
                    setServiceType(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.serviceType)
                    setServiceKey(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.serviceKey)
                    if (propertyDetails && propertyDetails.serviceType === "custom") {
                        setServiceProperties({
                            nodeId: nodeDetail.id,
                            name: propertyDetails && propertyDetails.name,
                            selectedserviceName: propertyDetails && propertyDetails.serviceName,
                            serviceKeyValue: combinedSericesParams.length > 0 ? combinedSericesParams : arr,
                            serviceKey: propertyDetails && propertyDetails.serviceKey && propertyDetails.servicekey,
                            serviceType: "custom",
                            nextNode: nextNode,
                            variableAcl
                        })
                    } else {
                        setServiceProperties({
                            nodeId: nodeDetail.id,
                            name: propertyDetails && propertyDetails.name,
                            selectedserviceName: propertyDetails && propertyDetails.serviceName,
                            serviceKeyValue: combinedSericesParams.length > 0 ? combinedSericesParams : arr,
                            nextNode: nextNode,
                            formKey: propertyDetails && propertyDetails.key,
                            selectedForm: propertyDetails && propertyDetails.selectedForm,
                            //serviceKey: propertyDetails && propertyDetails.serviceKey && propertyDetails.servicekey,
                            serviceType: propertyDetails && propertyDetails.serviceType,
                            variableAcl
                        })
                    }
                }
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "service") {
                setName(nodeDetail.id);
                setServiceName(nodeDetail.id);
                setId(0)
                setFormKey(null)
                setSelectedForm(null);
                setSelectedService("");
                setServiceValues([])
                setNextNode("")
                setShowAddIcon(true)
                setParamchanges(true)
                setShowAddParameter(true)
                setShowRequiredFields(false)
                setVariableAcl({})
            }
        }
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        if (form) {
            form.map((f: any) => {
                return (f.displayName === selectedForm) &&
                    setFormKey(f.formKey)
            })
        }
    }, [selectedForm])


    const filteredServiceKeyValue = (arr: any, serviceParamsKeyValue: any) => {
        const findKey = serviceParamsKeyValue.map((key: any) => {
            return key.key
        })
        const newKeyValue = arr.filter((keys: any) => {
            return findKey.includes(keys.key)
        })
        return newKeyValue
    }

    const findCurrentService = (currentService: any) => {
        const { params = {} } = currentService;
        if (Object.keys(params).length > 0) {
            setRequiredParams(currentService.requiredParams || [])
            setAdditionalParams(currentService.additionalParams)
            if (currentService.requiredParams && currentService.requiredParams.length > 0) {
                setShowRequiredFields(true)
            } else {
                setShowRequiredFields(false)
            }
            if (!currentService.additionalParams) {
                setShowAddParameter(false)
            } else {
                setShowAddParameter(true)
            }
        } else {
            setShowRequiredFields(false)
            setRequiredParams([])
            setShowAddParameter(true)
            setShowAddIcon(true)
        }

    }

    const findServiceKeyValue = (service: any, selectedServicename: any) => {
        let keyValue: any = {}
        let findSrc: any;
        const { propertyDetails = {} } = nodeDetail.data || {}
        const { params: serviceParam = {} } = propertyDetails
        const { params = {} } = service
        const keys = Object.keys(params)
        const { serviceName = "" } = nodeDetail.data && nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails || {}
        let findServicename: any;
        if (selectedServicename) {
            findServicename = selectedServicename
        } else {
            findServicename = serviceName
        }
        let newServices = (soloBuildinServices.concat(soloServices))
        const currService = newServices.find((item: any) => item.name === findServicename) || {}
        setRequiredParams(currService.requiredParams || []);
        const { requiredParams = [] } = currService
        const arr = keys.map((key: any) => {
            if (params) {
                findSrc = variablesTypes.findIndex((el: any) => el.type === params[key].type)
            }
            if (currService && currService.requiredParams && currService.requiredParams.length > 0) {
                currService.requiredParams.forEach((param: any) => {
                    if (key === param) {
                        setParamsRequiredfield(true)
                        setShowRequiredFields(true)
                    }
                    keyValue = {
                        id: key,
                        key: key,
                        value: serviceParam[key] && serviceParam[key].value ? serviceParam[key].value : "",
                        type: params[key].type || "String",
                        src: findSrc > 0 ? variablesTypes[findSrc].src : StringIcon,
                        changeType: currService.params ? false : true,
                        required: requiredParams.includes(key) ? true : false,
                        showCloseIcon: currService.params && currService.additionalParams ? true : !currService.params ? true : false
                    }
                })
            } else {
                keyValue = {
                    id: key,
                    key: key,
                    value: serviceParam[key] && serviceParam[key].value ? serviceParam[key].value : "",
                    type: params[key].type || "String",
                    src: findSrc > 0 ? variablesTypes[findSrc].src : StringIcon,
                    changeType: currService.params ? false : true,
                    required: requiredParams.includes(key) ? true : false,
                    showCloseIcon: currService.params && currService.additionalParams ? true : !currService.params ? true : false
                }
            }
            return keyValue
        })
        return arr;
    }

    const addService = () => {
        const values = [...serviceValues]
        values.push({ id: id, key: "", typee: "", value: "", changeType: true, showCloseIcon: true })
        setServiceValues(values)
    }

    const serviceRemove = (i: any) => {
        const values = [...serviceValues];
        values.splice(i, 1);
        setServiceValues(values);
    }

    const addKeyInService = (e: any, i: any) => {
        const Names = serviceValues.map((el: any) => _.camelCase(el.key));
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...serviceValues]
                val[i].nameCheck = true;
                val[i].key = e.target.value.trim();
                setValueCheck(e.target.value)
                setServiceValues(val)
                setShowAddParameter(false)
                setDisableSave(true)
            } else {
                const values = [...serviceValues];
                values[i].key = e.target.value.trim();
                setValueCheck(e.target.value)
                values[i].nameCheck = false;
                setServiceValues(values);
                setShowAddParameter(true)
                setDisableSave(false)
            }
        } else {
            const values = [...serviceValues];
            values[i].key = e.target.value;
            values[i].nameCheck = false;
            setServiceValues(values)
            setShowAddParameter(true)
        }
    }

    const handleSpace = (e: any) => {
        if (e.keyCode === 32 || e.keyCode === 8) {
            setSpaceKeyPressed(true)
        } else {
            setSpaceKeyPressed(false)
        }
    };

    const addType = (e: any, i: any) => {
        const value = [...serviceValues];
        if (e.type === "Json") {
            value[i].value = ""
        }
        value[i].type = e.type || "String";
        value[i].src = e.src || StringIcon;
        setServiceValues(value);
    }

    const addValueInService = (i: any, value: any) => {
        const values = [...serviceValues];
        values[i].value = value;
        requiredParams && requiredParams.map((param: any) => {
            if (param === values[i].key) {
                if (values[i].value.length > 0) {
                    values[i].required = false
                    setParamsRequiredfield(false)
                    if (!additionalParams) {
                        setShowAddIcon(false)
                    }
                } else {
                    values[i].required = true
                    setParamsRequiredfield(true)
                    if (!additionalParams) {
                        setShowAddIcon(false)
                    }
                }
            }
        })
        setServiceValues(values);
    }

    const saveServices = () => {
        props.setWidgetDrawer(false)
        let KeyValue: any = [];
        let data = {};
        serviceValues.length > 0 && serviceValues.forEach((service: any) => {
            data = {
                id: service.id,
                key: service.key,
                value: service.value ? service.value.trim() : "",
                type: service.type ? service.type : "String",
                src: service.src ? service.src : StringIcon,
                showCloseIcon: service.showCloseIcon,
                changeType: service.changeType
            }
            return KeyValue.push(data)
        })

        if (serviceKey && soloBuildinServices && soloBuildinServices[0].name !== selectedService) {
            setServiceProperties({
                nodeId: nodeDetail.id,
                name: name,
                serviceKey: serviceKey && serviceKey,
                serviceType: serviceType && serviceType,
                formKey: formKey,
                selectedForm: selectedForm,
                selectedserviceName: selectedService,
                serviceKeyValue: KeyValue,
                idChange: true,
                nextNode: nextNode,
                variableAcl
            })
        } else {
            setServiceProperties({
                nodeId: nodeDetail.id,
                name: name,
                //serviceKey: serviceKey && serviceKey,
                formKey: formKey,
                selectedForm: selectedForm,
                serviceType: serviceType && serviceType,
                selectedserviceName: selectedService,
                serviceKeyValue: KeyValue,
                idChange: true,
                nextNode: nextNode,
                variableAcl
            })
        }
    }

    const SelectedType = (props: any) => {
        const { index, type } = props
        return (
            <div className={style.dropdown}
                onMouseLeave={() => {
                    setOpenDropDownTypes(null)
                }}
            >
                {variablesTypes.map((item: any) => {
                    return (
                        <div
                            onClick={() => {
                                addType(item, index);
                                setOpenDropDownTypes(null)
                            }}
                            key={item.type}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: type === item.type ? "space-between" : "",
                                color: type && type.type === item.type ? "#0F66C8" : "#000610",
                                marginBottom: "-15px"
                            }}>
                            {<img src={item.src} />}
                            <p style={{ marginTop: 13, marginRight: 25, fontSize: "15px" }}>
                                {item.type}
                            </p>
                            {type && type.type === item.type &&
                                < Icon type="check" style={{
                                    marginTop: "18px",
                                    marginRight: "10px",
                                    color: "#0F66C8"
                                }} />}
                        </div>
                    )
                })}
            </div>)
    }

    const closeModal = () => {
        setShowCodeEditor(false)
    }

    return (
        <>
            {!showVariableAcl && <>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className={style.conditionInput}>
                        <div style={{ width: "100%" }}>
                            <div className={style.label}>
                                <label >Name</label>
                            </div>
                            <Input
                                disabled={props.lock}
                                style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD" }}
                                value={name}
                                placeholder="Enter Node Name"
                                onChange={(e: any) => { setName(e.target.value); setServiceName(e.target.value) }}
                            />
                            {(props.nameCheck || !name) && <p style={{
                                color: "#FF0000",
                                opacity: props.nameCheck || !name ? 1 : 0,
                                position: "relative",
                                textAlign: "center",
                                margin: "5px",
                                fontSize: 14
                            }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
                        </div>
                    </div>
                    {!eventNodeServiceConnections?.includes(nodeDetail.id) && <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>}
                    <div style={{ overflow: "auto", maxHeight: window.innerHeight - 350 }}>
                        {!eventNodeServiceConnections?.includes(nodeDetail.id) && <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                            <div
                                className={style.label}
                                style={{ color: "#3c434a" }}
                            >
                                <label >Next Node</label>
                            </div>
                            <Select
                                showSearch
                                onChange={(e: any) => setNextNode(e)}
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                disabled={props.lock}
                                value={nextNode || undefined}
                                placeholder="Select the next node"
                                optionLabelProp="label"
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    color: "#000610",
                                    fontSize: 15
                                }}
                                mode="default"
                                size="large"
                                filterOption={(input, option: any) => {
                                    return (option && option.props)
                                        ?
                                        option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {nodes && nodes.map((el: any) => {
                                    return <Option
                                        key={el.id}
                                        value={el.id}
                                        label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                                        <div
                                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row" }}>
                                                <img alt="icons" src={el.data.icon} />
                                                <p
                                                    style={{
                                                        marginLeft: "8px",
                                                        marginTop: "14px",
                                                        color: el.id === nextNode ? "#0F66C8" : "#000610"
                                                    }}
                                                >
                                                    {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                                </p>
                                            </div>
                                            {el.id === nextNode &&
                                                < Icon type="check" style={{ color: "#0F66C8" }} />}
                                        </div>
                                    </Option>
                                })}
                            </Select>
                        </div>}
                        {!eventNodeServiceConnections?.includes(nodeDetail.id) && <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>}
                        {!eventNodeServiceConnections?.includes(nodeDetail.id) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                            <div className={style.label} >
                                <label> Waiting Form Screen</label>
                            </div>
                            <Select
                                showSearch
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                                disabled={props.lock}
                                placeholder="Select the form"
                                value={selectedForm || undefined}
                                size="large"
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    //border: "1px solid #CAD5E9",
                                    color: "#000610",
                                    fontSize: 15,
                                }}
                                optionLabelProp="label"
                                onChange={(e: any) => setSelectedForm(e)}
                                filterOption={(input, option: any) => {
                                    return (option && option.props && option.props.children) ?
                                        option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {form && form.map((item: any) => {
                                    return <Option
                                        key={item.formId}
                                        value={item.displayName}
                                        label={item.displayName}>
                                        <div
                                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <p style={{ marginTop: "10px", color: item.displayName === selectedForm ? "#0F66C8" : "#000610" }}>
                                                {item.displayName}
                                            </p>
                                            {item.displayName === selectedForm &&
                                                < Icon type="check" style={{ color: "#0F66C8" }} />}
                                        </div>
                                    </Option>
                                })}
                            </Select>
                        </div>}
                        <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                            <div className={style.label}>
                                <label>Service Name</label>
                            </div>
                            <Select
                                showSearch
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                disabled={props.lock}
                                placeholder="Select the service"
                                value={selectedService || undefined}
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    //border: "0px solid #CAD5E9",
                                    color: "#000610",
                                    fontSize: 15
                                }}
                                optionLabelProp="label"
                                size="large"
                                onChange={(e: any) => { setSelectedService(e); setParamchanges(true) }}
                                filterOption={(input, option: any) => {
                                    return (option && option.props) ?
                                        option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {services && services.map((item: any) => {
                                    return (
                                        <Option
                                            key={item.name}
                                            value={item.name}
                                            label={item.name}>
                                            <div
                                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div
                                                    style={{ display: "flex", flexDirection: "row" }}>
                                                    {item.serviceKey ? <img src={SoloServcie} /> : <img src={buildin} />}
                                                    <p
                                                        style={{
                                                            margin: "15px 5px",
                                                            color: item.name === selectedService ? "#0F66C8" : "#000610"
                                                        }}
                                                    >
                                                        {item.name}
                                                    </p>
                                                </div>
                                                {item.name === selectedService &&
                                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                                            </div>
                                        </Option>)
                                })}
                            </Select>
                        </div>
                        <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                        {(services && services.length > 0) && <div>
                            {serviceValues && serviceValues.length > 0 &&
                                <div className={style.label} style={{ padding: "0px 18px" }}>
                                    <label>Service Parameters</label>
                                </div>
                            }
                            {
                                selectedService === "Delete Session Variables" &&
                                <div style={{ display: "flex", padding: '0px 18px', fontSize: "13px", marginBottom: 10 }}>
                                    ( Note: <p style={{ color: "red", wordSpacing: 3 }}>*</p> requires atleast one parameter )
                                </div>
                            }
                            {selectedService !== "Delete Session Variables" && showRequiredFields &&
                                <div style={{ display: "flex", padding: '0px 18px', fontSize: "13px", marginBottom: 10 }}>
                                    ( Note: <p style={{ color: "red", wordSpacing: 3 }}>*</p> mentioned fields are Required parameters )
                                </div>}
                            <div style={{ border: "none", padding: "0 8px", marginBottom: "15px" }}
                                onMouseLeave={() => {
                                    setOpenDropDownTypes(null)
                                }}
                            >
                                {serviceValues && serviceValues.length > 0 && serviceValues.map((element: any, Index: any) => {
                                    return (
                                        <div
                                            key={element.id}
                                            style={{ marginBottom: 15, position: "relative", width: "100%" }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", marginBottom: 0, padding: "0px 5px" }}>
                                                <Input
                                                    onKeyDown={handleSpace}
                                                    required={element.required || paramsRequiredfield}
                                                    disabled={props.lock || !element.changeType}
                                                    style={{
                                                        marginLeft: 2,
                                                        height: "44px",
                                                        color: "#000610",
                                                        fontSize: 15,
                                                        border: element.nameCheck ? "1px solid #FF0000 !important" : "1px solid #909BAD"
                                                    }}
                                                    prefix={requiredParams && requiredParams.some((e: any) => e === element.key) ? <div key={Index} style={{ color: "red", position: "absolute", marginTop: "-20px", fontSize: "18px", left: "-6px" }}  >*</div> : <div></div>}
                                                    placeholder="key"
                                                    value={element.key || ""}
                                                    className={element.nameCheck ? "serviceKeyError" : ""}
                                                    onChange={(e) => { setShowAddIcon(true); addKeyInService(e, Index) }}
                                                />
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        marginLeft: "16px",
                                                        width: "100%",
                                                        border: "1px solid #909BAD",
                                                        height: "44px",
                                                        borderRadius: 8,
                                                        position: "relative"
                                                    }}>
                                                    <div
                                                        onClick={() => {
                                                            setOpenDropDownTypes(openDropDownType === element.id ? null : element.id); setFindIndex(Index); setSelectedType(element.type ? element : { type: "String" })
                                                        }}
                                                    >
                                                        <img style={{ cursor: element.changeType ? "pointer" : "not-allowed" }} src={element.src || StringIcon} />
                                                    </div>
                                                    {openDropDownType === element.id && element.changeType &&
                                                        <Popover
                                                            className="service-type"
                                                            overlayClassName="overlay-service-type"
                                                            placement="bottom"
                                                            content={<SelectedType index={findIndex} type={selectedType} />}
                                                            visible={openDropDownType === element.id && element.changeType}
                                                            trigger="hover"
                                                        />
                                                    }
                                                    <Input
                                                        onMouseLeave={() => {
                                                            setOpenDropDownTypes(null)
                                                        }}
                                                        //type={element.type === "Integer" ? "number" : "string"}
                                                        required={element.required || paramsRequiredfield}
                                                        disabled={props.lock}
                                                        style={{
                                                            marginLeft: "-10px",
                                                            height: "40px",
                                                            color: "#000610",
                                                            fontSize: 15,
                                                            flex: "4",
                                                            border: 'none'
                                                        }}
                                                        placeholder="value"
                                                        value={element.value || ""}
                                                        readOnly={element.type === "Json"}
                                                        onClick={() => { element.type === "Json" && setShowCodeEditor(true); setJsonValue(serviceValues.length > 0 ? serviceValues[Index].value : ""); setFindJsonIndex(Index) }}
                                                        onChange={(e) => { addValueInService(Index, e.target.value) }}
                                                    />
                                                    {showCodeEditor &&
                                                        <CodeEditior
                                                            handleExpression={addValueInService}
                                                            id={findJsonIndex}
                                                            lang="Json"
                                                            values={jsonValue}
                                                            close={closeModal}
                                                        />}
                                                </div>
                                                {element.changeType && element.showCloseIcon ? <div
                                                    style={{ display: "flex", justifyContent: "center", marginLeft: props.lock ? "2px" : "10px" }}>
                                                    {!props.lock && <img
                                                        alt="cancel"
                                                        style={{ height: "44px", width: "80px", cursor: "pointer" }}
                                                        src={cancelSvg}
                                                        onClick={() => { serviceRemove(Index); setShowAddIcon(true); setShowAddParameter(true) }}
                                                    />}
                                                </div> : serviceValues.some((e: any) => e.changeType === true) &&
                                                <div style={props.lock ? { display: "flex", justifyContent: "center", marginLeft: props.lock ? "2px" : "10px" } : { marginRight: 15, padding: "0px 6px" }}>{!props.lock &&
                                                    <img
                                                        style={{ height: "65px", marginLeft: 15 }}
                                                        src={""} />}
                                                </div>}
                                            </div>
                                            {element.nameCheck && <p style={{
                                                color: "#FF0000",
                                                opacity: element.nameCheck ? 1 : 0,
                                                position: "relative",
                                                padding: "0px 17px",
                                                fontSize: 14
                                            }}>{"Key already exist"}</p>}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>}
                        {showAddIcon && services && services.length > 0 && showAddParameter && selectedService && !props.lock && <div
                            style={{
                                display: "flex",
                                padding: "0px 22px",
                                marginBottom: "15px"
                            }}>
                            <Button
                                style={{ height: "40px" }}
                                type="primary"
                                onClick={() => {
                                    addService();
                                    setId((prevState: any) => prevState + 1);
                                    setShowAddIcon(false)
                                }}>ADD PARAMETERS</Button>
                        </div>}
                    </div>
                </div>
                {<div className={style.footer}>
                    {!props.nameCheck && !props.lock && <Button
                        disabled={!name || serviceValues && serviceValues.some((e: any) => e.required === true && !e.value) || disableSave || !check}
                        style={{ backgroundColor: "#51808C", color: "#FFFFFF", width: "100%", height: 50 }}
                        onClick={saveServices} >APPLY</Button>}
                </div>}
            </>}
            {showVariableAcl && <VariableAcl
                variableAcl={variableAcl}
                setVariableAcl={setVariableAcl}
                teardownActiveTab={teardownActiveTab}
                setTeardownActiveTab={setTeardownActiveTab}
                setupActiveTab={setupActiveTab}
                setSetupActiveTab={setSetupActiveTab}
                setShowVariableAcl={setShowVariableAcl}
                name={name}
                lock={props.lock}>
            </VariableAcl>}
        </>)
}


export default Service;
